/// <reference types="@types/google.maps" />
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Veterinaria } from 'src/core/veterinaria/veterinaria.types';
import { VeterinariaService } from 'src/core/veterinaria/veterianaria.service';
import { ThemePalette } from '@angular/material/core';
import { User } from 'src/core/user/user.types';
import { AuthService } from 'src/core/auth/auth.service';

@Component({
  selector: 'app-map-veterinarias',
  templateUrl: './map-veterinarias.component.html',
  styleUrls: ['./map-veterinarias.component.css']
})
export class MapVeterinariasComponent implements OnInit {
      // Guardar los marcadores actuales para poder limpiarlos
      private markers: google.maps.Marker[] = [];
      private markerIndex: Map<string, google.maps.Marker> = new Map();

      toggleTipoC() {
        this.isTipoCActive = !this.isTipoCActive;
        this.limpiarMarcadores();
        if (this.isTipoCActive) {
          this.cargarVeterinarias(this.tipoCVeterinarias);
        } else {
          // Restaurar según el estado de isChecked
          if (this.isChecked) {
            this.cargarVeterinarias(this.urgencias);
          } else {
            this.cargarVeterinarias(this.veterinarias);
          }
        }
      }

      limpiarMarcadores() {
        if (this.markers && this.markers.length) {
          this.markers.forEach(marker => marker.setMap(null));
          this.markers = [];
        }
        this.markerIndex.clear();
      }
    limpiarTipoCDeVeterinarias() {
      if (!this.veterinarias) {
        this.tipoCVeterinarias = [];
        return;
      }
      this.tipoCVeterinarias = this.veterinarias.filter(vet => vet.fullJornada === 2);
      this.veterinarias = this.veterinarias.filter(vet => vet.fullJornada !== 2);
    }
  color: ThemePalette = 'warn';
  isChecked = true;
  isTipoCActive = false; // Estado para filtro tipo C
  urgencias: Veterinaria[] = [];
  tipoCVeterinarias: Veterinaria[] = []; // Lista para tipo C
  userSessionIsChecked = false;
  userSession: User = {} as User;

  directionsRenderer: google.maps.DirectionsRenderer;
  directionsService: google.maps.DirectionsService;
  userMarker: google.maps.Marker | null = null;
  infoWindow: google.maps.InfoWindow;


  @Input('veterinarias') veterinarias: Veterinaria[];
  map: google.maps.Map;
  mapOptions: google.maps.MapOptions;
  currentLocation: { lat: number, lng: number };
  constructor(
    private _router: Router,
    private _veterinariaService: VeterinariaService,
    private _authService: AuthService
  ) { }
  ngOnInit(): void {
    this.getCurrentLocation();
    this.limpiarTipoCDeVeterinarias();
    this.filtrarUrgencias();
    this.verificarUsuarioLogeado();
    this.directionsService = new google.maps.DirectionsService();
    this.directionsRenderer = new google.maps.DirectionsRenderer({
      suppressMarkers: false // Mostrar marcadores predeterminados
    });
    this.directionsRenderer.setMap(this.map);
    this.infoWindow = new google.maps.InfoWindow();
  }

  addMarkers(): void {
    const lista = this.isChecked ? this.urgencias : this.veterinarias;

    const listaOrdenada = lista.slice().sort((a, b) => {
      const distA = this.calcularDistancia(this.currentLocation, { lat: +a.latitud, lng: +a.longitud });
      const distB = this.calcularDistancia(this.currentLocation, { lat: +b.latitud, lng: +b.longitud });
      return distA - distB;
    });

    if (this.isChecked) {
      this.urgencias = listaOrdenada;
    } else {
      this.veterinarias = listaOrdenada;
    }

    this.cargarVeterinarias(lista);
  }

  private calcularDistancia(p1: { lat: number, lng: number }, p2: { lat: number, lng: number }): number {
    const R = 6371; // Radio de la tierra en km
    const dLat = this.deg2rad(p2.lat - p1.lat);
    const dLng = this.deg2rad(p2.lng - p1.lng);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(p1.lat)) * Math.cos(this.deg2rad(p2.lat)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distancia = R * c; // distancia en kilómetros
    return distancia;
  }

  private deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  cargarVeterinarias(veterinarias: Veterinaria[]): void {
    veterinarias.forEach(vet => this.addMarker(vet, 'location-vet.png'));
  }

  agregarUrgencias(): void {
    this.urgencias.forEach(vet => {
      this.addMarker(vet, 'location-vet.png')
    });
  }
  agregarVeterinariayUrgencias(): void {
    this.veterinarias.forEach(vet => {
      this.addMarker(vet, 'location-vet.png')
    });
  }
  async filtrarTipoC() {
    this.tipoCVeterinarias = await this.veterinarias?.filter(vet => vet.fullJornada === 2) || [];
    console.log('Tipo C Veterinarias: ', this.tipoCVeterinarias);
  }
  addMarker(vet, icon, track = true) {
    const marker = new google.maps.Marker({
      position: { lat: +vet.latitud, lng: +vet.longitud },
      map: this.map,
      icon: {
        url: '/assets/images/' + icon, // Ruta al icono cargado
        scaledSize: new google.maps.Size(50, 50), // Tamaño del icono
        origin: new google.maps.Point(0, 0), // Origen del icono
        anchor: new google.maps.Point(25, 25) // Punto de anclaje del icono
      },
      title: vet.nombre || ''
    });
    if (track) {
      this.markers.push(marker);
      this.markerIndex.set(this.markerKey(vet), marker);
    } else {
      this.userMarker = marker;
    }
    const infoContent = `
        <div>
          <h3>${vet.nombre}</h3>
          <p>Horario: ${vet.horaApertura} - ${vet.horaCierre}</p>
          <p>${vet.otros || 'Información adicional no disponible'}</p>
          <a href="https://www.google.com/maps?q=${vet.latitud},${vet.longitud}"  target="_blank"
         style="color: blue; font-size: 18px; text-decoration: underline;">
           Ver en Google Maps
          </a>
        </div>
      `;

    marker.addListener("click", () => {
      this.mostrarRuta(vet);
      if (!this.infoWindow) {
        this.infoWindow = new google.maps.InfoWindow();
      }
      this.infoWindow.setContent(infoContent);
      this.infoWindow.open(this.map, marker);
      setTimeout(() => {
        const btnRuta = document.getElementById(`btnRuta${vet.latitud}${vet.longitud}`);
        if (btnRuta) {
          btnRuta.addEventListener("click", () => this.mostrarRuta(vet));
        }
      }, 100);
    });
  }

  enfocarVet(vet: Veterinaria, zoom = 14): void {
    const marker = this.markerIndex.get(this.markerKey(vet));
    if (!marker || !this.map) {
      return;
    }
    this.map.panTo(marker.getPosition());
    if (zoom) {
      this.map.setZoom(zoom);
    }
    const infoContent = `
        <div>
          <h3>${vet.nombre}</h3>
          <p>Horario: ${vet.horaApertura} - ${vet.horaCierre}</p>
          <p>${vet.otros || 'Información adicional no disponible'}</p>
          <a href="https://www.google.com/maps?q=${vet.latitud},${vet.longitud}"  target="_blank"
         style="color: blue; font-size: 18px; text-decoration: underline;">
           Ver en Google Maps
          </a>
        </div>
      `;
    if (!this.infoWindow) {
      this.infoWindow = new google.maps.InfoWindow();
    }
    this.infoWindow.setContent(infoContent);
    this.infoWindow.open(this.map, marker);
  }

  mostrarRuta(destino: Veterinaria): void {
    if (!this.currentLocation || !this.directionsService || !this.directionsRenderer) {
      console.error("Error: ubicación o servicios no definidos.");
      return;
    }

    const request: google.maps.DirectionsRequest = {
      origin: this.currentLocation,
      destination: { lat: +destino.latitud, lng: +destino.longitud },
      travelMode: google.maps.TravelMode.DRIVING
    };

    this.directionsService.route(request, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        this.directionsRenderer.setDirections(result);
      } else {
        console.error("No se pudo calcular la ruta", status);
      }
    });
  }

  getCurrentLocation(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(resp => {

        this.currentLocation = { lng: resp.coords.longitude, lat: resp.coords.latitude };
        this.mapOptions = {
          center: this.currentLocation,
          zoom: 12.65
        };
        if (this.userMarker) {
          this.userMarker.setMap(null);
        }
        this.map = new google.maps.Map(document.getElementById("mappets") as HTMLElement, this.mapOptions);
        this.addMarker({ latitud: this.currentLocation.lat, longitud: this.currentLocation.lng }, 'location-person-pet.png', false);
        this.addMarkers()
        //console.log('current location : ', this.currentLocation);
      },
        err => {
          console.log(err);
        });
    } else {
      console.error('La geolocalización no es soportada por este navegador.');
    }
  }

  goToAgendarCita(vet: Veterinaria) {
    this._veterinariaService.veterinaria = vet;
    this._router.navigate(['/client/schedule-appointment']);
  }
  filtrarUrgencias() {
    if (!this.veterinarias) {
      this.urgencias = [];
      return;
    }
    this.urgencias = this.veterinarias.filter(vet => vet.fullJornada === 1);
    this.veterinarias = this.veterinarias.filter(vet => vet.fullJornada === 0);
  }
  onToggleChange() {
    this.getCurrentLocation();
  }

  verificarUsuarioLogeado(): void {
    const usuario = this._authService.obtenerTokenBearer();
    if (usuario != null) {
      // console.log('guarda True');
      this.isChecked = false;
      this.userSessionIsChecked = true;
    } else {
      // console.log('guarda false');
      this.userSessionIsChecked = false;
    }
    this.addMarkers();
  }

  private markerKey(vet: { latitud: number | string; longitud: number | string }): string {
    return `${vet.latitud}_${vet.longitud}`;
  }
}